/** Cross-request cache TTL for public SEO resolve responses (seconds). */
export const SEO_RESOLVE_REVALIDATE_SECONDS = 60;

/** Cross-request cache TTL for catalog filter dictionaries (seconds). */
export const FILTER_OPTIONS_REVALIDATE_SECONDS = 60;

/** Cross-request cache TTL for fandom characters hub listings (seconds). */
export const CHARACTERS_HUB_REVALIDATE_SECONDS = 60;
